import React from "react";
import { withStyles } from "@material-ui/core";
import Dropdown from "../../../../../../../common/Dropdown";

const styles = (theme) => ({
  valueContainer: {
    display: "flex",
  },
  reactSelect: {
    "& .select__control": {
      padding: 4,
    },
  },
});

const CustomDropdown = (props) => {
  const { classes, value, ...others } = props;

  return (
    <div className={classes.valueContainer}>
      <Dropdown
        value={value}
        {...others}
        customReactSelectClass={classes.reactSelect}
      />
    </div>
  );
};

export default withStyles(styles)(CustomDropdown);
